import {Component, OnInit, Input, Output, EventEmitter, HostListener, ViewChild, ElementRef} from '@angular/core';
import { SortQuery, SortOption } from '../../shared/domain/sort';
import { Observable } from 'rxjs/Observable';

@Component({
    selector   : 'nw-dropdown-sort',
    templateUrl: './dropdown-sort.component.html'
})
export class DropdownSortComponent implements OnInit {
    @Input() id = 'sort';
    @Input() sortOptionData: Observable<Array<SortOption>> = Observable.of([]);
    @Input() screenSize = 'lg';
    @Output() sortHandler: EventEmitter<SortQuery> = new EventEmitter();
    @ViewChild('dropDownButton') dropDownButton: ElementRef;

    dropdownLabel = '';
    selectedItem: SortOption;
    optionData: Array<SortOption>;
    dropdownClicked =  false;
    showMobileView = false;

    private model: SortQuery = {
        sortByValue: '',
        isDesc     : false
    };

    constructor() {}

    ngOnInit() {
        this.sortOptionData.subscribe((res) => {
            this.optionData = res;
            this.selectedItem = this.optionData.find(item => item['isSelected'] && item['isSelected'] === true);
            this.updateView();
        });
    }

    updateModel() {
        // reset the sort option order
        if (this.model.isDesc !== this.selectedItem['isDesc']) {
            this.selectedItem['isDesc'] = !this.selectedItem['isDesc'];
        }
        // update selected option
        this.model = {
            sortByValue: this.selectedItem['sortByValue'],
            isDesc     : this.selectedItem['isDesc']
        };
        // toggle the arrows on click and on exit
        this.dropdownClicked = !this.dropdownClicked;
    }

    updateView() {
        // update selected option
        this.model = {
            sortByValue: this.selectedItem['sortByValue'],
            isDesc     : this.selectedItem['isDesc']
        };
        // update dropdown label
        this.dropdownLabel = this.selectedItem['label'];
        this.dropdownLabel += ' - ';
        this.dropdownLabel += (this.selectedItem['isDesc'] ? this.selectedItem['labelDesc'] : this.selectedItem['labelAsce']);
    }

    apply() {
        this.showMobileView = false;
        setTimeout( () => {
            // remove previous selected item
            delete this.selectedItem['isSelected'];
            // apply new selected item
            this.selectedItem = this.optionData.find(item => item['sortByValue'] === this.model.sortByValue);
            this.selectedItem['isSelected'] = true;
            this.updateView();
            // pass action
            this.model.isDesc = this.selectedItem['isDesc'];
            this.sortHandler.emit(this.model);
        }, 1000)
    }

    stopClosingMenu($event) {
        $event.stopPropagation();
    }
    // logic to listen to the outside click event for toggle dropdown icon
    @HostListener('document:click', ['$event']) documentClick(event) {
        if (this.dropDownButton && !this.dropDownButton.nativeElement.contains(event.target))  {
            this.dropdownClicked = false;
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/@nw/ui-watchlist/components/dropdown-sort/dropdown-sort.component.ts